import { eventStreamService } from 'core-roblox-utilities';
import { parseEventParams } from '../utils/parsingUtils';

const {
  eventTypes: { pageLoad, formInteraction }
} = eventStreamService;

export enum EventStreamMetadata {
  AbsPositions = 'absPositions',
  AdsPositions = 'adsPositions',
  Algorithm = 'algorithm',
  EmphasisFlag = 'emphasisFlag',
  GameSetTargetId = 'gameSetTargetId',
  GameSetTypeId = 'gameSetTypeId',
  IsAd = 'isAd',
  NativeAdData = 'nativeAdData',
  NumberOfLoadedTiles = 'numberOfLoadedTiles',
  Page = 'page',
  PlaceId = 'placeId',
  Position = 'position',
  RootPlaceIds = 'rootPlaceIds',
  SortId = 'sortId',
  SortPos = 'sortPos',
  SuggestionKwd = 'suggestionKwd',
  SuggestionReplacedKwd = 'suggestionReplacedKwd',
  SuggestionCorrectedKwd = 'suggestionCorrectedKwd',
  SuggestionAlgorithm = 'suggestionAlgorithm',
  Topics = 'topics',
  TreatmentType = 'treatmentType',
  UniverseId = 'universeId',
  UniverseIds = 'universeIds'
}

export enum EventType {
  GameImpressions = 'gameImpressions',
  GameDetailReferral = 'gameDetailReferral',
  SortDetailReferral = 'sortDetailReferral',
  GenreExplorerRender = 'genreExplorerRender'
}

export enum PageContext {
  SearchPage = 'searchPage',
  SortDetailPageDiscover = 'sortDetailPageDiscover',
  SortDetailPageHome = 'sortDetailPageHome',
  GameDetailPage = 'gameDetailPage',
  GamesPage = 'gamesPage',
  HomePage = 'homePage'
}

export enum SessionInfoType {
  HomePageSessionInfo = 'homePageSessionInfo',
  GameSearchSessionInfo = 'gameSearchSessionInfo',
  DiscoverPageSessionInfo = 'discoverPageSessionInfo'
}

export type TEvent = [
  { name: string; type: EventType; context: string },
  Record<string, string | number>
];

export type TGridGameImpressions = {
  [EventStreamMetadata.RootPlaceIds]: number[];
  [EventStreamMetadata.AbsPositions]: number[];
  [EventStreamMetadata.AdsPositions]: number[];
  [EventStreamMetadata.UniverseIds]: number[];
  [EventStreamMetadata.SuggestionKwd]?: string;
  [EventStreamMetadata.SuggestionReplacedKwd]?: string;
  [EventStreamMetadata.SuggestionCorrectedKwd]?: string;
  [EventStreamMetadata.SuggestionAlgorithm]?: string;
  [EventStreamMetadata.Algorithm]?: string;
  [SessionInfoType.GameSearchSessionInfo]?: string;
  [SessionInfoType.HomePageSessionInfo]?: string;
  [EventStreamMetadata.EmphasisFlag]: boolean;
  [EventStreamMetadata.Page]:
    | PageContext.SearchPage
    | PageContext.SortDetailPageDiscover
    | PageContext.SortDetailPageHome;
};

export type TCarouselGameImpressions = {
  [EventStreamMetadata.RootPlaceIds]: number[];
  [EventStreamMetadata.UniverseIds]: number[];
  [EventStreamMetadata.AbsPositions]: number[];
  [EventStreamMetadata.SortPos]: number;
  [EventStreamMetadata.GameSetTypeId]?: number;
  [SessionInfoType.HomePageSessionInfo]?: string;
  [SessionInfoType.DiscoverPageSessionInfo]?: string;
  [EventStreamMetadata.Page]:
    | PageContext.SortDetailPageDiscover
    | PageContext.SortDetailPageHome
    | PageContext.HomePage
    | PageContext.GamesPage
    | PageContext.GameDetailPage;
};

export type TGameImpressions = TCarouselGameImpressions | TGridGameImpressions;

export type TSortDetailReferral =
  | {
      [EventStreamMetadata.Position]: number;
      [EventStreamMetadata.SortId]: number;
      [SessionInfoType.HomePageSessionInfo]?: string;
      [EventStreamMetadata.TreatmentType]?: string;
      [EventStreamMetadata.Page]: PageContext.HomePage;
    }
  | Record<string, never>;

export type TGameDetailReferral =
  | {
      [EventStreamMetadata.PlaceId]: number;
      [EventStreamMetadata.UniverseId]: number;
      [EventStreamMetadata.IsAd]?: boolean;
      [EventStreamMetadata.NativeAdData]?: string;
      [EventStreamMetadata.Position]: number;
      [EventStreamMetadata.SortPos]?: number;
      [EventStreamMetadata.NumberOfLoadedTiles]?: number;
      [EventStreamMetadata.GameSetTypeId]?: number;
      [EventStreamMetadata.GameSetTargetId]?: number;
      [SessionInfoType.GameSearchSessionInfo]?: string;
      [SessionInfoType.HomePageSessionInfo]?: string;
      [EventStreamMetadata.Page]:
        | PageContext.SearchPage
        | PageContext.SortDetailPageDiscover
        | PageContext.SortDetailPageHome
        | PageContext.HomePage
        | PageContext.GameDetailPage;
    }
  | Record<string, never>;

export type TGenreExplorerRender = {
  [EventStreamMetadata.Topics]: number[];
  [SessionInfoType.HomePageSessionInfo]?: string;
  [EventStreamMetadata.Page]: PageContext.HomePage;
};

export default {
  [EventType.GameImpressions]: ({ ...params }: TGameImpressions): TEvent => [
    {
      name: EventType.GameImpressions,
      type: EventType.GameImpressions,
      context: formInteraction
    },
    parseEventParams({
      ...params
    })
  ],
  [EventType.GameDetailReferral]: (params: TGameDetailReferral = {}): TEvent => [
    {
      name: EventType.GameDetailReferral,
      type: EventType.GameDetailReferral,
      context: pageLoad
    },
    parseEventParams({ ...params })
  ],
  [EventType.SortDetailReferral]: (params: TSortDetailReferral = {}): TEvent => [
    {
      name: EventType.SortDetailReferral,
      type: EventType.SortDetailReferral,
      context: pageLoad
    },
    parseEventParams({
      ...params
    })
  ],
  [EventType.GenreExplorerRender]: (params: TGenreExplorerRender): TEvent => [
    {
      name: EventType.GenreExplorerRender,
      type: EventType.GenreExplorerRender,
      context: pageLoad
    },
    parseEventParams({
      ...params
    })
  ]
};
